import { defineComponent as _defineComponent } from 'vue'
import type { YoutubePlayerOptions } from '@/interfaces/components/youtube-player';
import type { SnowplowContext } from '@/helpers/tracking/providers';
import { toValue, type MaybeRefOrGetter } from '@vueuse/core';

import NewDesignModal from '@/components/modals/NewDesignModal.vue';
import { useRoutingStore } from '@/helpers/composables/useStores';
import { ModalHelper } from '@/helpers/modal-helper';

import { computed, watch } from 'vue';
import type { TrailerClip } from '@/interfaces/trailerClip';
import { getTrailerComponent } from '@/helpers/trailer-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrailerModal',
  props: {
    clips: null,
    titleName: null,
    source: { default: 'modal' },
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { clips: MaybeRefOrGetter<TrailerClip[]>, titleName: string, source: string, additionalContexts: SnowplowContext[] };



const options: YoutubePlayerOptions = { autoplay: 1, mute: 1 };

const { activeRoute } = useRoutingStore();

watch(
	() => activeRoute,
	() => ModalHelper.close()
);

const trailerClip = computed(() => toValue(props.clips)[0]);

const videoPlayer = computed(() => {
	return getTrailerComponent(trailerClip.value?.provider);
});

return { __sfc: true,props, options, activeRoute, trailerClip, videoPlayer, NewDesignModal }
}

})